

























































































































































































import { ConsultoresService, Consultor } from "@/services/consultores.service";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { cpf, date, dateTime, telefone } from "@/shared/filters";
import AlterarTelefone from "../modals/AlterarTelefone.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import EditarObservacao from "../modals/EditarObservacao.vue";

@Component({
  components: {
    Tooltip,
    AlterarTelefone,
    EditarObservacao,
  },
  filters: { cpf, date, dateTime, telefone },
})
export default class ConsultorSelecionado extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  consultor: Consultor | null = null;
  loading = false;

  mounted() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async fetchConsultoresSelecionado(idConsultor: number) {
    this.loading = true;
    try {
      this.consultor = await ConsultoresService.ObterDadosConsultor(
        idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  public atualizarConsultorSelecionado() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  trocarConsultor() {
    this.$router.push({
      name: "home",
    });
  }

  async alterarNumeroTelefone(tipo: number) {
    const modal = this.$refs.alterarTelefone as AlterarTelefone;
    if (tipo == 1) {
      await modal.editarTelefone(
        this.idConsultor,
        tipo,
        this.consultor!.telefone + ""
      );
    } else {
      await modal.editarTelefone(
        this.idConsultor,
        tipo,
        this.consultor!.celular + ""
      );
    }

    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async editarObservacao() {
    const modal = this.$refs.editarObservacao as EditarObservacao;
    await modal.abrirModalObservacao(this.consultor!.observacao);
    this.fetchConsultoresSelecionado(this.idConsultor);
  }
}
